import * as React from "react";
import { topLoaderProgress } from "../../configs";

export function useTopLoader(loading: boolean) {
  const [progress, setProgress] = React.useState(0);
  const timerRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (loading) {
      setProgress((p) => (p === 0 ? topLoaderProgress.start : p));

      if (!timerRef.current) {
        timerRef.current = window.setInterval(() => {
          setProgress((p) => {
            const target = topLoaderProgress.ceilingWhileLoading;
            const delta = Math.max(1, (target - p) * 0.12);
            return Math.min(target, p + delta);
          });
        }, 250);
      }
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      setProgress((p) => (p < 95 ? 95 : p));
      const id = window.setTimeout(
        () => setProgress(topLoaderProgress.complete),
        50
      );
      return () => clearTimeout(id);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [loading]);

  const handleFinished = React.useCallback(() => setProgress(0), []);

  return { progress, handleFinished };
}
